import classNames from "classnames";
import React, { useMemo } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useCareCommentThreadList } from "../../hooks/care_comment/useCareCommentThreadList";
import { Loading } from "../common/Loading";
import { CareCommentThreadItem } from "./CareCommentThreadItem";
import { NoData } from "../common/no_data/NoData";

export const CareCommentThreadList = React.memo(function CareCommentThreadList() {
    const careCommentThreadList = useCareCommentThreadList();

    const distinctMonthList = useMemo(() => (
        Array.from(
            new Set(careCommentThreadList?.map(careCommentThread => careCommentThread.careComments.slice(-1)[0].createdTime.date.getMonth().japaneseFormat()))
        )
    ), [careCommentThreadList]);

    if (!careCommentThreadList) return <Loading />;

    if (!careCommentThreadList.length) return <NoData message={"ケアコメントがありません"} />;

    return (
        <>
            {distinctMonthList.map(month => {
                const careCommentThreadListMatchedMonth = careCommentThreadList.filter(careCommentThread => careCommentThread.careComments.slice(-1)[0].createdTime.date.getMonth().japaneseFormat() === month);

                return (
                    <React.Fragment key={month}>
                        {/* 年月 */}
                        <h2 className={"year_month"}>{month}</h2>
                        {/* ケアコメントスレッド */}
                        <TransitionGroup>
                            {/* keyにcareCommentThread.Idを使うと継続掲示の方とkeyが重複して再renderが正常に動作しなくなるのでuuidを使用する */}
                            {careCommentThreadListMatchedMonth.map(careCommentThread =>
                                <CSSTransition key={careCommentThread.id.value} timeout={500} classNames="item">
                                    <li className={classNames("care_comment_row", { "mark_as_read": careCommentThread.careComments.every(careComment => careComment.isRead) })}>
                                        <CareCommentThreadItem careCommentThread={careCommentThread} />
                                    </li>
                                </CSSTransition>
                            )}
                        </TransitionGroup>
                    </React.Fragment>
                );
            })}
        </>
    );
});
